import { apiGet, apiDelete, apiPatch, apiPost, apiPut } from '../common';

function wrappedApiCall(apiCall: typeof apiGet) {
  return <TReturn = any>(url: string, data?: any, namespace?: string) =>
    new Promise<TReturn>((resolve, reject) => {
      apiCall(url, data, resolve, reject, namespace);
    });
}

const FetchPromise = {
  get: wrappedApiCall(apiGet),
  post: wrappedApiCall(apiPost),
  patch: wrappedApiCall(apiPatch),
  put: wrappedApiCall(apiPut),
  delete: wrappedApiCall(apiDelete),
};

export default FetchPromise;
